import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useBrandsSelector = () => useSelector((state: StateExtended) => state.brands.brands);
